import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import StepWizard from 'react-step-wizard'
import moment from 'moment'
import { DayPickerRangeController } from 'react-dates'
import { handleAppointmentSubmit } from './Functions'
import { Checkbox } from 'primereact/checkbox'
import { Spinner, TextareaAuto, Input, Text, Flex, Button, Card } from '@Common/Components'
import { getUrlParams, translateWeekDays, months } from '@Common/Services'
import { useMount } from 'react-use'

const gray = 'rgba(90, 90, 90, 0.85)'

export const Header = ({ agency }) => {
  const { logo, name, note } = agency
  return logo
    ? (
      <Flex style={{ margin: 10, height: '100%' }}>
        <img src={logo} style={{ width: '50%' }} alt='logo' />
        <Text center bold size={24} value={name} />
        <Text color={gray} center value={note} style={{ marginTop: 10 }} size={14} />
        <hr style={{ border: '1px solid white', width: '90%' }} />
      </Flex>)
    : <Spinner />
}

export const MobileWizard = ({
  formData: [formData, setFormData], displayRange: [displayRange, setDisplayRange], range: [range, setRange],
  displayAppointmentType: [displayAppointmentType, setDisplayAppointmentType], appointmentType: [appointmentType, setAppointmentType],
  dateId: [dateId, setDateId], date: [date, setDate], calendarId: [calendarId, setCalendarId], calendar: [calendar, setCalendar],
  displayCalendar: [displayCalendar, setDisplayCalendar], labelNumber: [labelNumber, setLabelNumber],
  width: width2, previousStep, agency
}) => {
  const childRef = useRef(null)
  const values = [displayCalendar, appointmentType, date, range, formData?.name]

  const [step, setStep] = useState(1)

  const BottomBar = () => step !== 1 && (
    <Flex js row style={{ zIndex: 5, backgroundColor: 'white', position: 'absolute', bottom: 20, width: '94%', height: 60, borderRadius: 20 }}>
      <Button rich label='Indietro' styleText={{ color: '#9FD066' }} style={{ border: '3px solid #9FD066', cursor: 'pointer', width: '35%', margin: '2%', marginRight: '26%' }} onClick={() => childRef.current.previousStep()} />
      <Button rich label='Avanti' styleText={{ color: values[step - 1] ? '#9FD066' : 'gainsboro' }} style={{ border: values[step - 1] ? '3px solid #9FD066' : '3px solid gainsboro', cursor: values[step - 1] ? 'pointer' : 'not-allowed', margin: '2%', width: '35%' }} onClick={() => values[step - 1] && childRef.current.nextStep()} />
    </Flex>)

  return (
    <>
      <Flex js fw>
        <Card style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '105%', marginBottom: 80 }}>
          <Header agency={agency} />
          <Flex>
            <Text bold size={18} center value='PRENOTA ONLINE UN APPUNTAMENTO CON NOI' />
          </Flex>
          <Flex style={{ marginTop: 20 }}>
            <StepWizard onStepChange={({ activeStep }) => setStep(activeStep)}>
              <SelectCalendar ref={childRef} agency={agency} setCalendar={setCalendar} setCalendarId={setCalendarId} setDisplayCalendar={setDisplayCalendar} />
              <AppointmentType agency={agency} calendarIndex={calendar} setAppointmentType={setAppointmentType} setDisplayAppointment={setDisplayAppointmentType} />
              <SelectDate agency={agency} setDateId={setDateId} calendarIndex={calendar} date={date} setDate={setDate} />
              <SelectHour agency={agency} calendarIndex={calendar} date={date} setDisplayRange={setDisplayRange} setRange={setRange} />
              <Form setFormData={setFormData} range={range} formData={formData} appointmentType={appointmentType} date={dateId} calendar={calendarId} agency={agency} />
              <EndWizard />
            </StepWizard>
          </Flex>
        </Card>
        <BottomBar />
      </Flex>
    </>
  )
}

export const SelectCalendar = forwardRef(({ currentStep, previousStep, nextStep, agency, setCalendar, setCalendarId, setDisplayCalendar }, ref) => {
  if (!agency.appointments) return null
  const { calendars = [] } = agency.appointments || {}
  const cal = getUrlParams('cal')

  useImperativeHandle(ref, () => ({
    previousStep () {
      previousStep()
    },
    nextStep () {
      nextStep()
    }
  }))

  useMount(() => {
    if (cal) {
      const foundCal = calendars.find((calendar) => calendar.id.toString() === cal)
      const ind = calendars.findIndex((calendar) => calendar.id.toString() === cal)
      if (foundCal) {
        nextStep()
        setCalendar(ind)
        setCalendarId(foundCal.id)
        setDisplayCalendar(foundCal.name + '-' + foundCal.service)
      }
    }
  })

  return (
    <Flex fw wrap row>
      {calendars.find(cal => cal.enabled)
        ? calendars.map((cal, ind) => cal.enabled && (
          <Card
            key={ind} onClick={() => { nextStep(); setCalendar(ind); setCalendarId(cal.id); setDisplayCalendar(cal.name + '-' + cal.service) }}
            style={{ backgroundColor: 'white', cursor: 'pointer', minHeight: 80, width: '46%', margin: '2%', justifyContent: 'center', border: '2px solid #9FD066' }}
          >
            {cal?.operator?.name && <Text center bold size={14} value={cal?.operator?.name + ' ' + cal?.operator?.lastName} />}
            {cal?.operator?.avatar && <img src={'https://s3.eu-central-1.amazonaws.com/siap.apptour.uploads/' + cal?.operator?.avatar} style={{ borderRadius: 20, width: '50%', margin: '0px 25%' }} />}
            <Text center bold size={14} value={(cal?.name || '') + (cal.service ? ' - ' : '') + (cal.service || '')} />
          </Card>))
        : (
          <Card><Text center bold size={18} value='Nessun calendario disponibile' /></Card>)}
    </Flex>
  )
})

const appointmentTypes = {
  SE: 'Sede',
  OF: 'Ufficio',
  TE: 'Telefono',
  VI: 'Videoconferenza'
}

export const AppointmentType = ({ nextStep, previousStep, agency, calendarIndex, setAppointmentType, setDisplayAppointment }) => {
  const { calendars = [] } = agency?.appointments || {}
  const calendar = calendars[calendarIndex]
  return (
    <Flex row wrap>
      <Card style={{ backgroundColor: 'white', width: '100%', border: '2px solid #9FD066' }}>
        <Text center bold size={18} value="Come vuoi svolgere l'appuntamento?" />
        <Text center size={16} color='rgba(90, 90, 90, 0.55)' value='Clicca per selezionare la modalità preferita' />
        <Flex row style={{ marginTop: 20 }} wrap>
          {calendar?.typeOfAppointment?.length
            ? calendar.typeOfAppointment.map((type, ind) =>
              <Button key={ind} onClick={() => { nextStep(); setAppointmentType(appointmentTypes[type]); setDisplayAppointment(appointmentTypes[type]) }} rich label={appointmentTypes[type]} styleText={{ color: '#9FD066' }} style={{ border: '3px solid #9FD066', width: '46%', margin: '2%' }} />)
            : Object.entries(appointmentTypes).map(([key, value]) =>
              <Button key={key} onClick={() => { nextStep(); setAppointmentType(value); setDisplayAppointment(value) }} rich label={value} styleText={{ color: '#9FD066', fontSize: 14 }} style={{ border: '3px solid #9FD066', width: '46%', margin: '2%' }} />
            )}
        </Flex>
      </Card>
      <div style={{ flexBasis: '100%' }} />
    </Flex>
  )
}

const getId = (date) => moment(date).diff(moment('2020-06-01'), 'days')

export const SelectDate = ({ agency, nextStep, setDateId, calendarIndex, date, setDate }) => {
  const { calendars = [] } = agency?.appointments || {}

  const calendar = calendars[calendarIndex]
  const isDayBlocked = (day) => !day || !calendar || !calendar.openings || day.isBefore(moment().add(-1, 'day')) || !calendar.openings.find((o) => o.dayId === getId(day))

  return (
    <Flex row>
      {calendar &&
        <Flex style={{ boxShadow: 'rgb(100 100 100 / 24%) 0px 4px 13px 3px', border: '2px solid #9FD066', borderRadius: 20 }}>
          <DayPickerRangeController
            hideKeyboardShortcutsPanel
            startDate={date ? moment(date) : null}
            endDate={null}
            onDatesChange={({ startDate }) => { setDate(startDate); nextStep(); setDateId(getId(startDate)) }}
            focusedInput='startDate'
            isDayHighlighted={(day) => false}
            isDayBlocked={isDayBlocked}
            firstDayOfWeek={1}
            renderMonthElement={({ month }) => <Text center bold size={18} value={`${months?.[month.format('MMMM')]} ${month.format('YYYY')}`} />}
            renderDayContents={translateWeekDays}
          />
        </Flex>}
    </Flex>
  )
}

export const SelectHour = ({ agency, calendarIndex, date, nextStep, setDisplayRange, setRange }) => {
  const { calendars = [] } = agency?.appointments || {}
  const calendar = calendars[calendarIndex]
  const idDate = getId(date)
  let calendarOfTheDay
  if (calendar) calendarOfTheDay = calendar?.openings?.find((item) => item.dayId === idDate)
  return (
    <Flex row>
      <Card style={{ backgroundColor: 'white', width: '100%', border: '2px solid #9FD066' }}>
        <Text center bold size={16} value='Orario' />
        <Text center size={14} color='rgba(90, 90, 90, 0.55)' value="Seleziona l'ora dell'appuntamento" />
        <Flex wrap row>
          {calendarOfTheDay &&
            calendarOfTheDay.timeSlots.map((slot, index) =>
              <Button
                key={index}
                onClick={() => {
                  if (slot.state === 'available') {
                    nextStep(); setDisplayRange(`${slot.fromDisplay} - ${slot.toDisplay}`); setRange(slot.id)
                  }
                }} rich label={slot.fromDisplay} styleText={{ color: slot.state === 'available' ? '#9FD066' : 'gainsboro' }}
                style={{ border: slot.state === 'available' ? '3px solid #9FD066' : '3px solid gainsboro', cursor: slot.state === 'available' ? 'pointer' : 'not-allowed', width: '35%', margin: '2%', marginRight: '2%', marginLeft: '2%' }}
              />
            )}
        </Flex>
      </Card>
    </Flex>
  )
}

export const Form = ({ setFormData, goToStep, currentStep, nextStep, range, formData, appointmentType, date, calendar, agency }) => {
  const [name, setName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [info, setInfo] = useState('')
  const [errorLabel, setErrorLabel] = useState('')
  const [privacyChecked, setPrivacyChecked] = useState(false)

  const dataCheck = () => {
    !email && setErrorLabel("Inserisci l'email")
    !phoneNumber && setErrorLabel('Inserisci il numero di cellulare')
    !lastName && setErrorLabel('Inserisci il cognome')
    !name && setErrorLabel('Inserisci il nome')
    !privacyChecked && setErrorLabel('Devi acconsentire il trattamento dei dati')
    return !!(email && phoneNumber && lastName && name && privacyChecked)
  }

  const handleForm = () => {
    if (dataCheck()) {
      setErrorLabel('')
      handleAppointmentSubmit(agency._id, range, {
        name,
        surname: lastName,
        phone: phoneNumber,
        email,
        ...(info ? { request: info } : {})
      }, appointmentType, date, calendar)
      nextStep()
    }
  }

  return (
    <Flex row>
      <Card style={{ backgroundColor: 'white', width: '100%', border: '2px solid #9FD066' }}>
        <Text center bold size={18} value='Inserisci i tuoi dati' />
        <Text center size={16} color='rgba(90, 90, 90, 0.55)' value='Completa la richiesta inderendo i tuoi dati' />
        <Flex style={{ paddingTop: 20 }}>
          <Input id='name' placeholder='Nome' style={{ width: '85%', marginBottom: 20, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} value={name} onChange={(e) => setName(e.name)} />
          <Input id='lastName' value={lastName} onChange={(e) => setLastName(e.lastName)} placeholder='Cognome' style={{ width: '85%', marginBottom: 20, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <Input id='phoneNumber' placeholder='Cellulare' value={phoneNumber} onChange={(e) => setPhoneNumber(e.phoneNumber)} style={{ width: '85%', marginBottom: 20, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <Input id='email' value={email} onChange={(e) => setEmail(e.email)} placeholder='Email' style={{ width: '85%', marginBottom: 20, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <TextareaAuto id='info' value={info} onChange={(e) => setInfo(e.target.value)} style={{ backgroundColor: 'rgba(231, 231, 231, 0.8)', width: '85%', marginBottom: 20, fontSize: 16 }} placeholder='A cosa sei interessato?' />
          <Text style={{ width: '100%', marginBottom: 0, fontSize: 18 }} color='red' center value={errorLabel} />
          <Flex row fw>
            <Checkbox checked={privacyChecked} onChange={(e) => setPrivacyChecked(!privacyChecked)} />
            <Text value='Acconsento al trattamento dei dati e info privacy' style={{ marginLeft: 5 }} />
          </Flex>
          <Button label='Inoltra richiesta' rich styleText={{ color: '#9FD066' }} style={{ border: '3px solid #9FD066', marginTop: 20 }} onClick={handleForm} />
        </Flex>
      </Card>
    </Flex>
  )
}

export const EndWizard = ({ currentStep, goToStep }) => {
  return (
    <Flex>
      <Card style={{ backgroundColor: 'white', width: '100%', height: '90%', display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center' }}>
        <Text size={20} bold center value='Grazie per inviato la tua richiesta di appuntamento!' />
        <Text size={16} color={gray} center value="Attendi l'email di conferma, riceverai tutte le istruzioni per poter partecipare all'evento." />
        <Button style={{ textDecoration: 'underline', backgroundColor: '#9FD066', color: 'white', marginTop: 20 }} label='Invia una nuova richiesta' onClick={() => window.location.reload()} />
      </Card>
    </Flex>
  )
}
